import { createRouter, createWebHistory, RouteRecordRaw, type NavigationGuardNext, type RouteLocationNormalized } from "vue-router";
import { useAuthStore } from "@/store/AuthStore";
import middlewarePipeline from "@/router/middlewarePipeline";
import guardLogin from "@/router/middleware/guardLogin";
import requireAuth from "@/router/middleware/requireAuth";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: () => import(/* webpackChunkName: "login" */ "../views/HomeView.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import(/* webpackChunkName: "login" */ "../views/LoginView.vue"),
    meta: {
      middleware: [guardLogin],
    },
  },
  {
    path: "/book/:h0?/:h1?/:h2?/:h3?/:page?",
    name: "Book",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "book" */ "../views/BookView.vue"),
  },
  {
    path: "/register",
    name: "Register",
    component: () => import(/* webpackChunkName: "register" */ "../views/RegisterView.vue"),
  },
  {
    path: "/confirm_email/:confirm_token",
    name: "Confirm Email",
    component: () => import(/* webpackChunkName: "register" */ "../views/ConfirmEmailView.vue"),
  },
  {
    path: "/admin",
    name: "Admin",
    component: () => import(/* webpackChunkName: "admin" */ "../views/AdminView.vue"),
    meta: {
      middleware: [requireAuth],
    },
  },
  {
    path: "/forgot_password",
    name: "ForgotPassword",
    component: () => import(/* webpackChunkName: "login" */ "../views/ForgotPasswordView.vue"),
    meta: {
      middleware: [guardLogin],
    },
  },
  {
    path: "/reset_password/:reset_token",
    name: "ResetPassword",
    component: () => import(/* webpackChunkName: "register" */ "../views/ResetPasswordView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
  const authStore = useAuthStore();

  if (!to.meta.middleware) {
    return next();
  }
  const middleware = to.meta.middleware as any;

  const context = {
    to,
    from,
    next,
    authStore,
  };

  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1),
  });
});

export default router;
